var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TechContent"}},[_c('div',{staticClass:"title"},[_c('h3',[_vm._v("登陆注册")])])])
}]

export { render, staticRenderFns }